module.exports = __webpack_public_path__ + "img/tamfs.23a85d90.png";